import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_dialog_actions = _resolveComponent("ontos-dialog-actions")!
  const _component_ontos_view_class = _resolveComponent("ontos-view-class")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ontos_dialog = _resolveComponent("ontos-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_dialog, {
    "model-value": true,
    fullscreen: _ctx.$vuetify.display.smAndDown,
    "max-width": "1400px",
    "onUpdate:modelValue": _ctx.onDialogInput
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_ontos_view_class, {
            "idea-alias-prop": _ctx.ideaAlias,
            workspace: _ctx.workspace,
            onShowMessage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMessage', $event))),
            onShowErrorMessage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
          }, {
            controls: _withCtx(() => [
              _createVNode(_component_ontos_dialog_actions, {
                "full-page-route": _ctx.fullPageRoute,
                onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
              }, null, 8, ["full-page-route"])
            ]),
            _: 1
          }, 8, ["idea-alias-prop", "workspace"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["fullscreen", "onUpdate:modelValue"]))
}